import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Address from './address';
import Form from './form';
import { ColumnSection, Column } from '../column-section';
import SimpleSection from '../simple-section';
import LeafletMap from '../leaflet-map';
import { Helmet } from 'react-helmet';

import { Languages } from '../../tools/languages';

import './index.scss';

const Contact = ({ language }) => {
  return (
    <>
      <Helmet>
        <script src="https://www.google.com/recaptcha/api.js" async defer></script>
      </Helmet>

      <h1>Contact</h1>
      <ColumnSection id="contact-section">
        <Column>
          <Address language={language} />
        </Column>
        <Column>
          <Form language={language} />
        </Column>
      </ColumnSection>
      <ColumnSection>
        <Column>
          <SimpleSection id="location-info">
            <h3>{language === Languages.NL ? 'Locatie' : 'Location'}</h3>
            <ul>
              <li>Bavak Security Group / Bavak Beveiligingsgroep BV</li>
              <li>Zwarteweg 19</li>
              <li>2201 AA, Noordwijk</li>
              <li>Nederland</li>
            </ul>
            <a
              className="secondary-button"
              rel="noreferrer"
              href="https://www.google.com/maps?saddr=My+Location&daddr=Zwarteweg+19,+2201+AA+Noordwijk"
              target="_blank"
            >
              <FormattedMessage id="contact-directions" />
            </a>
          </SimpleSection>
        </Column>
        <Column>
          {typeof window !== 'undefined' && (
            <LeafletMap
              position={[52.21867683019847, 4.434188157613686, 17]}
              zoom={20}
              markerText={'Bavak Security Group'}
            />
          )}
        </Column>
      </ColumnSection>
    </>
  );
};

Contact.propTypes = {
  language: PropTypes.string.isRequired,
};

Contact.defaultProps = {
  language: Languages.EN,
};

export default Contact;
